// extracted by mini-css-extract-plugin
export default {"dataAugConfig":"DataAugConfig_dataAugConfig__4ctRD","displaySection":"DataAugConfig_displaySection__-h-8o"};